$(function () {
    let headernav = $('#headernav');

    $('.nav-toggle').on('click', function (event) {
        event.preventDefault();

        window.saveScrollPosition();

        headernav.fadeIn(function () {
            window.disable_scroll();
        });
    });

    $('.headernav__toggle').on('click', function (event) {
        event.preventDefault();

        window.enable_scroll();
        headernav.fadeOut();
    });

    $('.dropdown-menu-toggler').on('click', function () {
        let li = $(this).parent();
        let dropdown = $(this).next('.dropdown-menu');
        let icon = $(this).children('.fas');
        if (dropdown.css('display') === 'block') {
            dropdown.slideUp();
            li.removeClass('dropdown-open');
            icon.removeClass('fa-minus').addClass('fa-plus');
        } else {
            li.addClass('dropdown-open');
            dropdown.slideDown();
            icon.removeClass('fa-plus').addClass('fa-minus');
        }
    });

    $('.homepageheader__scroll').on('click', function (event) {
        event.preventDefault();

        const scrollAmount = headernav.outerHeight() - $('.navbar').outerHeight();

        $('html, body').animate({
            scrollTop: scrollAmount,
        }, 1000);
    });

    window.saveScrollPosition = function () {
        window.scroll_position = $('html').scrollTop();
    };

    window.disable_scroll = function () {
        $('body').css('position', 'fixed'); // ervoor zorgen dat de website (dus niet de modal maar de content achter de modal) niet meer gescrolled kan worden, vaak kan je op iOS Safari nog scrollen omdat de navigatiebar (onderaan het scherm) dan weggaat, dit houd dat tegen.
        $('body').css('overflow', 'hidden'); // ervoor zorgen dat de website (dus niet de modal maar de content achter de modal) niet meer gescrolled kan worden, vaak kan je op iOS Safari nog scrollen omdat de navigatiebar (onderaan het scherm) dan weggaat, dit houd dat tegen.
    };

    window.enable_scroll = function () {
        $('body').css('position', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $('body').css('overflow', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $('html').scrollTop(window.scroll_position); // 'scroll' positie terug zetten naar de waarde die het had voordat modal popup geopend was
    };

    $(document).on('keyup', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            if (!headernav.is(':visible')) {
                return;
            }

            window.enable_scroll();
            headernav.fadeOut();
        }
    });
});
